module.exports = "/_next/static/images/WhatIsCustomerData-92cfb4c61a1d8f0dcd4fa17f93aa3715.webp";